module.exports = __webpack_public_path__ + "img/image01.4487172b.jpg";